export const login = {
  // SSO Login
  EmailAddress: "Email Address",
  Fullscript: "Fullscript",
  SignIn: "Sign In",
  EnterEmail: "Please enter your email to continue",
  Builders: "We are builders at heart",
  BackToUserLogin: "Back to user login",
  SwitchToUSSite: "Switch To US Site",
  SwitchToCASite: "Switch To Canadian Site",
} as const;
